export const SET_IS_LOYALTY_PROGRAM_ACTIVE = 'src/store/loyalty/SET_IS_LOYALTY_PROGRAM_ACTIVE';
export const SET_IS_ASTRAPAY_CONNECTED = 'src/store/loyalty/SET_IS_ASTRAPAY_CONNECTED';
export const SET_ASTRAPPOINTS_VALUE = 'src/store/loyalty/SET_ASTRAPPOINTS_VALUE';
export const SET_ASTRAPAY_BALANCE = 'src/store/loyalty/SET_ASTRAPAY_BALANCE';
